<template>
<v-text-field
    class="v-text-field--outline nch--input nch--text-field__small v-text-field--enclosed"
    :class="settings.class"
    :name="settings.name"
    type="text"
    v-model="model"
    :label="$findTranslation(settings, lang).label"
    :rules="settings.data.required && !build
        ? [ v => !!v ||
            $t('validation.required', { attribute: $findTranslation(settings, lang).label }) ]
        : []"
>
    <template #prepend v-if="build">
        <span class="nch--order-indicator">
            {{ settings.order }}
        </span>
    </template>
</v-text-field>
</template>

<script>
export default {
    name: 'FbTextField',

    props: {
        value: String,
        modelValue: String,
        build: {
            type: Boolean,
            default: true,
        },
        lang: Object,
        settings: {
            type: Object,
            default: () => ({
                name: '',
                label: '',
                required: true,
                class: '',
            }),
        },
    },

    computed: {
        model: {
            get() { return this.modelValue !== undefined ? this.modelValue : this.value; },
            set(value) { this.$emit('update:modelValue', value); this.$emit('input', value); },
        },
    },
};

</script>

<style scoped>

    .nch--order-indicator {
        border-radius: 50%;
        border: 1px dashed rgb(var(--v-theme-info));
        text-align: center;
        line-height: 30px;
        width: 30px;
        height: 30px;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .fb-item__selected .v-input__prepend .nch--order-indicator {
        border-color: rgb(var(--v-theme-primary));
        color: rgb(var(--v-theme-primary));
    }
</style>
